"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const react_ga_1 = __importDefault(require("react-ga"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const constants_1 = require("../../assets/constants/constants");
const room_webp_1 = __importDefault(require("../../assets/images/room.webp"));
const HeaderMenuComponent_1 = __importDefault(require("../../components/headerMenuComponent/HeaderMenuComponent"));
const data_repository_1 = require("../../dataSource/data_repository");
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const detectDevice_1 = __importDefault(require("../../utils/detectDevice"));
const users_1 = require("../../utils/users");
const HomeFooter_1 = __importDefault(require("../home/homeFooter/HomeFooter"));
const BookBanner_1 = __importDefault(require("./bookBanner/BookBanner"));
const BookGalery_1 = __importDefault(require("./bookGalery/BookGalery"));
const BookSuiteStyles_1 = require("./BookSuiteStyles");
const SideMenu_1 = __importDefault(require("./sideMenu/SideMenu"));
const format_1 = require("../../utils/format");
const Properties_1 = require("../../hooks/Properties");
const FacebookPixelLocation_1 = require("../../components/facebookPixelLocation/FacebookPixelLocation");
const initialBookItemsData = {
    availableQuantity: 0,
    categories: [],
    bookList: [],
    isEmptyRooms: false,
};
function useQuery() {
    return new URLSearchParams((0, react_router_dom_1.useLocation)().search);
}
const inititalPageTitle = '360 Suítes - Reservas';
const defaultInititalPageDescription = 'Localizações estratégicas e flexibilidade.';
const BookSuite = () => {
    const query = useQuery();
    const getInititalPageDescription = () => {
        // Para garantir que o Google consiga indexar as páginas principais antes do get das informações
        try {
            const property = query.get('property');
            const currentProperty = property !== null ? JSON.parse(property) : [];
            if (currentProperty.length === 1) {
                const currentPropertyId = currentProperty[0].toString();
                switch (currentPropertyId) {
                    case '94677':
                        return 'Rua Tabatinguera, 462 - CEP: 03216-050';
                    case '94134':
                        return 'Rua Washington Luís 196 - CEP: 01033-010';
                    default:
                        return defaultInititalPageDescription;
                }
            }
        }
        catch (err) {
            return defaultInititalPageDescription;
        }
        return defaultInititalPageDescription;
    };
    const buildingActiveName = (0, react_redux_1.useSelector)(state => state.suitesReserve.roomActive);
    const buildingActive = (0, react_redux_1.useSelector)(state => state.suitesReserve);
    const history = (0, react_router_dom_1.useHistory)();
    const [pageTitle, setPageTitle] = (0, react_1.useState)(inititalPageTitle);
    const [pageDescription, setPageDescription] = (0, react_1.useState)(getInititalPageDescription());
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [queryURL, setQueryURL] = (0, react_1.useState)();
    const [bookItemsData, setBookItemsData] = (0, react_1.useState)(initialBookItemsData);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(0);
    const [isLastPage, setIsLastPage] = (0, react_1.useState)(true);
    const location = (0, react_router_dom_1.useLocation)();
    const [isClosed, setIsClosed] = (0, react_1.useState)(false);
    const { isDesktop } = (0, detectDevice_1.default)();
    const [requestError, setRequestError] = (0, react_1.useState)(false);
    const propContext = (0, Properties_1.useProperties)();
    const loadPageItems = (0, react_1.useCallback)((pageNumber, queryObj = false) => {
        var _a;
        let propertyValue = [];
        let categoryValue;
        let selectedDateValue;
        let guestsValue;
        if (queryObj) {
            // Busca com novos parametros
            propertyValue = queryObj === null || queryObj === void 0 ? void 0 : queryObj.property;
            categoryValue = queryObj === null || queryObj === void 0 ? void 0 : queryObj.category;
            selectedDateValue = queryObj === null || queryObj === void 0 ? void 0 : queryObj.selectedDate;
            guestsValue = queryObj === null || queryObj === void 0 ? void 0 : queryObj.guests;
            if (JSON.stringify(propertyValue) === JSON.stringify(queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) &&
                JSON.stringify(categoryValue) === JSON.stringify(queryURL === null || queryURL === void 0 ? void 0 : queryURL.category) &&
                JSON.stringify(selectedDateValue) === JSON.stringify(queryURL === null || queryURL === void 0 ? void 0 : queryURL.selectedDate) &&
                JSON.stringify(guestsValue) === JSON.stringify(queryURL === null || queryURL === void 0 ? void 0 : queryURL.guests)) {
                // URL foi alterada, mas nenhum filtro foi alterado
                setLoading(false);
                return;
            }
        }
        else {
            // Busca com mesmos parametros (carregar mais)
            propertyValue = queryURL === null || queryURL === void 0 ? void 0 : queryURL.property;
            categoryValue = queryURL === null || queryURL === void 0 ? void 0 : queryURL.category;
            selectedDateValue = queryURL === null || queryURL === void 0 ? void 0 : queryURL.selectedDate;
            guestsValue = queryURL === null || queryURL === void 0 ? void 0 : queryURL.guests;
        }
        const params = { pageNumber };
        if (propertyValue === null || propertyValue === void 0 ? void 0 : propertyValue.length) {
            params.propId = propertyValue;
        }
        if (selectedDateValue === null || selectedDateValue === void 0 ? void 0 : selectedDateValue.length) {
            const fromDate = (_a = selectedDateValue[0]) === null || _a === void 0 ? void 0 : _a.split('/').map(value => Number(value));
            const fromText = `${fromDate[2]}-${fromDate[1]}-${fromDate[0]}`;
            let toText = '';
            const from = new Date(fromDate[2], fromDate[1] - 1, fromDate[0]);
            let to = new Date();
            if (selectedDateValue[1]) {
                const toDate = selectedDateValue[1].split('/').map(value => Number(value));
                toText = `${toDate[2]}-${toDate[1]}-${toDate[0]}`;
                to = new Date(toDate[2], toDate[1] - 1, toDate[0]);
            }
            else {
                // caso tenha algum problema com data, remove a data da busca
                history.push(`${RoutesPaths_1.routesPaths.bookSuite}${location.search.split('&selectedDate')[0]}`);
                return;
            }
            // validações de data
            const dateTimeStringSP = new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
            const dateStringSP = dateTimeStringSP.split(' ')[0].split('/');
            const initialDate = new Date(Number(dateStringSP[2]), Number(dateStringSP[1]) - 1, Number(dateStringSP[0]));
            const finalDate = new Date(Number(dateStringSP[2]), Number(dateStringSP[1]) - 1, Number(dateStringSP[0]));
            finalDate.setFullYear(finalDate.getFullYear() + 1);
            finalDate.setDate(finalDate.getDate() - 1);
            // se a data inicial for maior que final, altera a URL e recomeça a busca
            if (from > to) {
                const url = location.search.split('&selectedDate')[0];
                history.push(`${RoutesPaths_1.routesPaths.bookSuite}${url}&selectedDate=["${selectedDateValue[1]}","${selectedDateValue[0]}"]`);
                return;
            }
            // se a data inicial for menor que a data de hoje
            if (from < initialDate && from.toLocaleDateString('pt-BR') !== initialDate.toLocaleDateString('pt-BR')) {
                // remove a data da busca
                history.push(`${RoutesPaths_1.routesPaths.bookSuite}${location.search.split('&selectedDate')[0]}`);
                return;
            }
            // se a data final for maior que o período de 1 ano
            if (to > finalDate && to.toLocaleDateString('pt-BR') !== finalDate.toLocaleDateString('pt-BR')) {
                // remove a data da busca
                history.push(`${RoutesPaths_1.routesPaths.bookSuite}${location.search.split('&selectedDate')[0]}`);
                return;
            }
            // caso tenha passado pelas validações, insere nos parametros
            params.from = (0, format_1.formatDateWithoutZero)(fromText);
            params.to = (0, format_1.formatDateWithoutZero)(toText);
        }
        if (guestsValue) {
            params.maxPeople = guestsValue.toString();
        }
        (0, data_repository_1.getAvailableRooms)(params)
            .then(response => {
            setLoading(false);
            if (!response.isError) {
                const currentLanguage = (0, users_1.getCurrentLanguage)();
                const responseBookList = response === null || response === void 0 ? void 0 : response.rooms.content.map((item) => {
                    const description = item.texts.find((textItem) => textItem.language === currentLanguage);
                    const gallery = item.images
                        .sort((a, b) => Number(a.position) - Number(b.position))
                        .map((imgItem, imgIdx) => (Object.assign(Object.assign({}, imgItem), { id: imgIdx })));
                    return {
                        propId: item.propId,
                        roomId: item.roomId,
                        suiteTitle: item.name,
                        buildingName: item.propName,
                        address: item.propAddress,
                        description: description ? description.roomDescription1 : '',
                        price: item.price,
                        priceValueFormatted: (0, format_1.getFormattedDouble)(item.price),
                        cleaningFee: constants_1.DEFAULT_CLEANING_FEE,
                        totalPrice: item.totalPrice,
                        discountPercent: item.discountPercent,
                        priceGross: item.priceGross,
                        priceGrossFormatted: (0, format_1.getFormattedDouble)(item.priceGross),
                        quantity: item.quantity,
                        maxPeople: item.maxPeople,
                        image: gallery[0] ? gallery[0].url : room_webp_1.default,
                        gallery: gallery.length ? gallery : [{ id: 0, url: room_webp_1.default }],
                        amenities: {
                            wifi: true,
                            compactKitchen: false,
                            balcony: true,
                            tvFurniture: false,
                            airConditioner: true,
                            security: false,
                        },
                        installations: {
                            parking: false,
                            pool: true,
                            reception24h: false,
                            gym: true,
                            laundry: false,
                            recreationAreas: true,
                        },
                    };
                });
                let bookList;
                if (pageNumber === 0) {
                    bookList = responseBookList;
                }
                else {
                    bookList = [...bookItemsData.bookList, ...responseBookList];
                }
                const objResponse = {
                    availableQuantity: response.rooms.totalElements,
                    categories: [],
                    bookList,
                    isEmptyRooms: response.emptyRooms,
                };
                setBookItemsData(objResponse);
                setIsLastPage(response.rooms.last);
                setCurrentPage(response.rooms.pageable.pageNumber);
                if (requestError)
                    setRequestError(false);
            }
            else {
                const objResponse = {
                    availableQuantity: 0,
                    categories: [],
                    bookList: [],
                    isEmptyRooms: true,
                };
                setBookItemsData(objResponse);
                setRequestError(true);
                antd_1.message.error('Erro ao carregar os dados');
            }
        })
            .catch(err => {
            console.error('Erro ', err);
            antd_1.message.error('Ocorreu um erro na requisição. Por favor, tente novamente mais tarde');
            setLoading(false);
        });
        react_ga_1.default.pageview(window.location.pathname + window.location.search);
        const checkin_date = selectedDateValue ? selectedDateValue[0] : '';
        const checkout_date = selectedDateValue ? selectedDateValue[1] : '';
        (0, FacebookPixelLocation_1.sendFBPixel)('ViewContent', {
            content_type: propertyValue,
            content_ids: '',
            city: 'São Paulo',
            region: 'São Paulo',
            country: 'BR',
            checkin_date,
            checkout_date,
        });
    }, [bookItemsData, history, location, queryURL]);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        const queryObj = {};
        try {
            const property = query.get('property');
            const category = query.get('category');
            const selectedDate = query.get('selectedDate');
            const guests = query.get('guests');
            queryObj.property = property !== null ? JSON.parse(property) : [];
            queryObj.category = category !== null ? JSON.parse(category) : [];
            queryObj.selectedDate = selectedDate !== null ? JSON.parse(selectedDate) : [];
            queryObj.guests = guests !== null ? JSON.parse(guests) : constants_1.DEFAULT_GUESTS_PER_ROOM;
        }
        catch (err) {
            queryObj.property = [];
            queryObj.category = [];
            queryObj.selectedDate = [];
            queryObj.guests = constants_1.DEFAULT_GUESTS_PER_ROOM;
        }
        finally {
            setQueryURL(queryObj);
        }
        loadPageItems(0, queryObj);
    }, [location]);
    (0, react_1.useEffect)(() => {
        var _a;
        let propertyArray;
        try {
            const property = query.get('property');
            propertyArray = property !== null ? JSON.parse(property) : [];
        }
        catch (err) {
            propertyArray = [];
        }
        if (buildingActiveName) {
            setPageTitle(`360 Suítes - Propriedade - ${buildingActiveName}`);
            setPageDescription(getInititalPageDescription());
        }
        else {
            try {
                if ((propertyArray === null || propertyArray === void 0 ? void 0 : propertyArray.length) >= 1) {
                    const propertyId = propertyArray[0];
                    const propertySelected = (_a = propContext === null || propContext === void 0 ? void 0 : propContext.properties) === null || _a === void 0 ? void 0 : _a.find(item => item.propId.toString() === propertyId);
                    if (propertySelected) {
                        setPageTitle(`360 Suítes - Propriedade - ${propertySelected.name.replace('360', '').trim()}`);
                        let propertyPageDescription = '';
                        if (propertySelected.address) {
                            let postcode = propertySelected.postcode.replace('CEP', '').trim();
                            postcode = postcode ? ` - CEP: ${postcode}` : '';
                            propertyPageDescription = `${propertySelected.address}${postcode}`;
                        }
                        setPageDescription(propertyPageDescription || getInititalPageDescription());
                    }
                    else {
                        setPageTitle(inititalPageTitle);
                        setPageDescription(getInititalPageDescription());
                    }
                }
                else {
                    setPageTitle(inititalPageTitle);
                    setPageDescription(getInititalPageDescription());
                }
            }
            catch (err) {
                setPageTitle(inititalPageTitle);
                setPageDescription(getInititalPageDescription());
            }
        }
    }, [location, propContext.properties, buildingActiveName]);
    const loadMore = (0, react_1.useCallback)(() => {
        loadPageItems(currentPage + 1);
    }, [currentPage, loadPageItems]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null, pageTitle),
            react_1.default.createElement("meta", { name: "description", content: pageDescription })),
        react_1.default.createElement(HeaderMenuComponent_1.default, null),
        react_1.default.createElement(BookSuiteStyles_1.ContainerBody, { className: `${isClosed && isDesktop ? 'closedContainer' : ''}`, fluid: true },
            queryURL && react_1.default.createElement(BookBanner_1.default, { properties: (queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) || [] }),
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { lg: isClosed && isDesktop ? 2 : 3, className: "transitionCol" },
                    react_1.default.createElement(SideMenu_1.default, { queryURL: queryURL, isClosed: isClosed, setIsClosed: setIsClosed })),
                react_1.default.createElement(react_bootstrap_1.Col, { lg: isClosed && isDesktop ? 10 : 9, className: "transitionCol" },
                    react_1.default.createElement(antd_1.Spin, { tip: "Carregando...", spinning: loading },
                        react_1.default.createElement(BookGalery_1.default, { data: bookItemsData, queryURL: queryURL, propertiesLength: (queryURL === null || queryURL === void 0 ? void 0 : queryURL.property) ? queryURL === null || queryURL === void 0 ? void 0 : queryURL.property.length : 0, loadMoreFunc: loadMore, isLastPage: isLastPage, requestError: requestError }))))),
        react_1.default.createElement(HomeFooter_1.default, null)));
};
exports.default = BookSuite;
